export enum ThemeChoices {
  PEANUTS = 1,
  VAN_WAGENINGEN,
  KALKMAN,
  COOLBLUE,
  PINK
}

export enum DarkTheme {
  LIGHT = "light",
  DARK = "dark",
  SYSTEM = "system"
}
